
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import { TFilter } from '@/common/components/redesigned/Filter/types/filter';
  import { TableEventTypes, TTableEventConfigs } from '@/common/components/redesigned/Table/types/tableTypes';
  import { TStorePaths } from '@/common/types/storePaths';

  import { EVENTS_TABLE_ACTIONS } from '../../constants/constants';
  import { DASHBOARDS_VES_ACTIONS_NAME, DASHBOARDS_VES_GETTERS_NAME } from '../../store/dashboards/name';
  import { MINISTRY_EVENTS_STORE_PATHS } from '../../store/events/name';
  import { TDashboardsTableFilter, TDashboardsTableItem } from '../../types/dashboards';
  import { TEventsTableActions, TEventsTableItem } from '../../types/events';
  import { getEventCardRoute } from '../../utils/router';
  import AddVESEventCard from '../AddVESEventCard.vue';
  import EventsBaseTable from './EventsBaseTable.vue';
  import { actionsColumn, ministryEventColumns } from './eventsTableColumns';
  import { getEventsTableParams } from './eventsTableParams';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  export default defineComponent({
    name: 'MinistryEventsTable',
    components: { EventsBaseTable, ButtonComponent, AddVESEventCard },
    props: {
      params: {
        type: Object as PropType<Partial<TDashboardsTableFilter>>,
        default: () => ({}),
      },
      editable: {
        type: Boolean,
        default: false,
      },
    },
    provide() {
      return {
        [EVENTS_TABLE_ACTIONS]: {
          onEdit: (row: TEventsTableItem) => this.onEditEvent(row),
          onDeleted: () => this.refreshTable(),
        } as TEventsTableActions,
      };
    },
    data(): {
      storePaths: TStorePaths;
      isCreateModalOpen: boolean;
      editEventId: number | null;
      updateTrigger: number;
    } {
      return {
        storePaths: MINISTRY_EVENTS_STORE_PATHS,
        isCreateModalOpen: false,
        editEventId: null,
        updateTrigger: 0,
      };
    },
    created() {
      if (this.editable) {
        this.getEventVedTypes();
        this.getEventStatuses();
        this.getPartnerCountrySearchId();
      }
    },
    computed: {
      ...mapGetters({
        eventVedTypes: DASHBOARDS_VES_GETTERS_NAME.getEventVedTypes,
        eventStatuses: DASHBOARDS_VES_GETTERS_NAME.getEventStatuses,
        partnerCountryList: DIRECTIVES_GETTERS_NAME.getPartnerCountrySearchIdList,
      }),
      columns() {
        return this.editable ? [...ministryEventColumns, actionsColumn] : ministryEventColumns;
      },
      tableParams(): TFilter {
        return getEventsTableParams(true, this.params);
      },
      eventConfigs(): TTableEventConfigs<TDashboardsTableItem> {
        return [
          {
            type: TableEventTypes.ROW_CLICK,
            func: (item) => this.$router.push(getEventCardRoute(item.id, true)),
          },
        ];
      },
    },
    methods: {
      ...mapActions({
        getEventVedTypes: DASHBOARDS_VES_ACTIONS_NAME.getEventVedTypes,
        getEventStatuses: DASHBOARDS_VES_ACTIONS_NAME.getEventStatuses,
        getPartnerCountrySearchId: DIRECTIVES_ACTIONS_NAME.getPartnerCountrySearchId,
      }),
      openCreateModal() {
        this.editEventId = null;
        this.isCreateModalOpen = true;
      },
      onEditEvent(row: TEventsTableItem) {
        this.editEventId = row.id;
        this.isCreateModalOpen = true;
      },
      onModalToggle(isOpen: boolean) {
        if (!isOpen) this.editEventId = null;
      },
      refreshTable() {
        this.updateTrigger += 1;
      },
    },
  });
